module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-staappr"
  }, [_c('div', {
    staticClass: "header-paper clearfix clear-shadow"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.labels['coddescempid'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.currentCodempid) + " - " + _vm._s(_vm.currentDescCodempid))])]), _vm._v(" "), _c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.labels['dteempdbym'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.detailIndexY) + " ปี " + _vm._s(_vm.detailIndexM) + " เดือน")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 pull-right clear-padding"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['year'][_vm.nowLang]))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row "
  }, [_c('hrms-dropdown-year', {
    attrs: {
      "nowLang": _vm.nowLang
    },
    model: {
      value: (_vm.paramSearchYear),
      callback: function($$v) {
        _vm.paramSearchYear = $$v
      },
      expression: "paramSearchYear"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46ac57e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/componentStaappr.vue
// module id = 3727
// module chunks = 1